import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { loadContratos, loadContrato, resetContratoForm } from '../../redux-flow/actions/contratos';
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import FormContrato from './FormContrato'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Card } from 'antd'
import CookieConsentComponent from '../../Components/CookieConsent'
import { dadosBancarios } from '../../constants'
import theme from '../../config/theme';

import './contratos.css'

class Contratos extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            fillBackground: false,
            tipoContrato: 11
        }
    }

    handleChange = (value) => {
        this.setState({
            tipoContrato: value
        })
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        if (onLoad && userid) {
            onLoad(this.props.userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        const {
            logged,
            userLogged,
            permissao
        } = this.props

        return (
            logged ? (
                /* Regra comentada pois todos podem criar investimentos
                userLogged.permissao === 0 || userLogged.permissao === 1 || userLogged.permissao === 5 || userLogged.permissao === 4 ?(
                <Redirect to="meusinvestimentos" />
                ) : 
                */
                <div>
                <Navbar userLogged={userLogged} loggedArea={true} />
                <div class="section minhaContaWrapper novoContratoWrapper">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h4 className="pageTitle text-white">Dê início a sua jornada de investimentos.</h4>
                                <hr />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div class="section insideSec gerarContrato mt-5">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <Card title="">
                                    <Row>
                                        <Col md={7}>
                                            <FormContrato handleChange={this.handleChange} tipoContrato={this.state.tipoContrato}/>
                                        </Col>
                                            {this.state.tipoContrato === 6 ?
                                                <Col md={5}>
                                                    <div className="limiterDeposito">
                                                        <h6 style={{color: theme.colors.primaryDark}}>Faça o depósito para a conta.</h6>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Banco: </label><br />
                                                            <label className="text-white">{dadosBancarios.banco}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Nome: </label><br />
                                                            <label className="text-white">{dadosBancarios.nome}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>CNPJ: </label><br />
                                                            <label className="text-white">{dadosBancarios.cnpj}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Agência: </label><br />
                                                            <label className="text-white">{dadosBancarios.agencia}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Conta: </label><br />
                                                            <label className="text-white">{dadosBancarios.conta}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Chave PIX (CNPJ): </label><br />
                                                            <label className="text-white">{dadosBancarios.pix}</label>
                                                        </div>
                                                    </div>
                                                </Col>
                                            :
                                                <Col md={5}>
                                                    <div className="limiterDeposito">
                                                        <h6 style={{color: theme.colors.primaryDark}}>Faça o depósito para a conta.</h6>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Banco: </label><br />
                                                            <label className="text-white">{dadosBancarios.banco}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Nome: </label><br />
                                                            <label className="text-white">{dadosBancarios.nome}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>CNPJ: </label><br />
                                                            <label className="text-white">{dadosBancarios.cnpj}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Agência: </label><br />
                                                            <label className="text-white">{dadosBancarios.agencia}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Conta: </label><br />
                                                            <label className="text-white">{dadosBancarios.conta}</label>
                                                        </div>
                                                        <div className="limiterBancoInfo">
                                                            <label style={{color: theme.colors.primaryDark}}>Chave PIX (CNPJ): </label><br />
                                                            <label className="text-white">{dadosBancarios.pix}</label>
                                                        </div>
                                                    </div>
                                                </Col>
                                            }
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <CookieConsentComponent />
                </div>
            ) : (
                <Redirect to="/login" />
            )
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    permissao: state.login.permissao,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(resetContratoForm())
        dispatch(fetchUserInfo(id))
        dispatch(loadContratos(id, (contratos, callback = () => {}) => {
            const [ contrato = {} ] = contratos || []
            if (Object.keys(contrato)) {
                dispatch(loadContrato(contrato.id))
            }
            callback()
        }))
    },
    onSelectContrato: idContrato => dispatch(loadContrato(idContrato))
})

export default connect(mapStateToProps, mapDispatchToProps)(Contratos)